import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { DurationPerYearFilter } from './duration-per-year-filter.model';
import { IEntityFilters } from '../../entity-data/entity-data.data';

export const APPOINTMENT_FILTERS_SCHEMA = Object.freeze({
  DURATION_PER_YEARS: List<DurationPerYearFilter>([]),
});
const RECORD = generateSchema(APPOINTMENT_FILTERS_SCHEMA);
const KEYS: any = generateKeys(APPOINTMENT_FILTERS_SCHEMA);

export class AppointmentFilters
  extends Record(RECORD)
  implements IEntityFilters {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    return setInModel(this, [
      {
        key: KEYS.DURATION_PER_YEARS,
        value: props.get(KEYS.DURATION_PER_YEARS)
          ? this.durationPerYearFilters.map(
              (params) => new DurationPerYearFilter(params)
            )
          : List<DurationPerYearFilter>([]),
      },
    ]) as AppointmentFilters;
  }

  get durationPerYearFilters(): List<DurationPerYearFilter> {
    return this.get(KEYS.DURATION_PER_YEARS);
  }
}
